const HealthSVG = () => {
  return (
    <svg
      className="fill-neutralLight"
      width="100%"
      height="100%"
      // viewBox="0 0 200 200"
      viewBox="-0.5 -5 33 32"
      xmlns="http://www.w3.org/2000/svg">
      <g
        id="Group_10"
        data-name="Group 10"
        transform="translate(-238.002 -468.195)">
        <path
          id="Path_378"
          data-name="Path 378"
          d="M269.3,473.692A8.99,8.99,0,0,0,261,468.2a7.686,7.686,0,0,0-3.5.864,9.587,9.587,0,0,0-2.86,2.272c-.226.26-.436.534-.637.816-.2-.282-.41-.556-.636-.816a9.6,9.6,0,0,0-2.86-2.272,7.69,7.69,0,0,0-3.5-.864,9,9,0,0,0-6.364,15.365c.814.813,12.288,11.179,13.364,11.635,1.076-.456,12.55-10.822,13.364-11.635a9.012,9.012,0,0,0,1.929-9.868ZM260,483.7h-4v4h-4v-4h-4v-4h4v-4h4v4h4Z"
        />
      </g>
    </svg>
  );
};

export default HealthSVG;
